$(document).ready(function () {

    // accordion
    let $sectionPanelCollapse = $('.section-faq .panel-collapse');
    $sectionPanelCollapse.on('show.bs.collapse', function () {
        $(this).parent().addClass('opened');
    });
    $sectionPanelCollapse.on('hide.bs.collapse', function () {
        $(this).parent().removeClass('opened');
    });


    // center tab
    function centerActiveCategory() {
        if (window.innerWidth < 767) {
            const $activeCategory = $('.section-faq .nav-tabs .item.position-center');

            if ($activeCategory.length) {
                const $scrollContainer = $('.section-faq .wrap-scroll');
                const activeOffsetLeft = $activeCategory[0].offsetLeft;
                const activeWidth = $activeCategory.outerWidth();
                const containerWidth = $scrollContainer.width();
                const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);
                $scrollContainer.animate({scrollLeft: scrollPosition}, 300, 'swing');
            }
        }
    }

    centerActiveCategory();

    $('.section-faq .nav-tabs .item a').on('click', function (e) {
        e.preventDefault();
        const $parentItem = $(this).parent();
        $parentItem.addClass('position-center').siblings().removeClass('position-center');
        centerActiveCategory();
    });
});

